if (!window.dropdownHoverInitialized) {
  window.dropdownHoverInitialized = true;

  // Event delegation on document
  document.addEventListener('mouseover', function(e) {
    const dropdown = e.target.closest('.utility-bar__dropdown, .trust-pilot-bar__dropdown');
    if (dropdown) {
      clearTimeout(dropdown._closeTimer);
      dropdown.setAttribute('open', '');
    }
  });

  document.addEventListener('mouseout', function(e) {
    const dropdown = e.target.closest('.utility-bar__dropdown, .trust-pilot-bar__dropdown');
    if (dropdown && !dropdown.contains(e.relatedTarget)) {
      dropdown._closeTimer = setTimeout(() => dropdown.removeAttribute('open'), 200);
    }
  });
}
